import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/payrollOfPartner/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/payrollOfPartner/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/payrollOfPartner/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/payrollOfPartner/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/payrollOfPartner/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/payrollOfPartner/delete',
      method: 'delete',
      params: data
    })
  }
}
